// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","EmployeeTile":"EmployeeTile-snjhtfe4qf5s1qp9f52expabdqhwqebntrdzderjpkzs1yqaswfcqubzx7fxumzh2n3y6nhjqhdsg67t9qcvar4h58ff2zwhdad3sa","Avatar":"Avatar-2kwvgpmu18g1g1hj6k4jyur7e9jb1cdue2xm91r5nqyguagg51xsc1xfsqxnjd17kp46g7j33sx93hg75gdbvejb1utrmhzrrrfh2x1","loading":"loading-2ejje79gmmsjvsgtzzenfpf828fu4c7w2mrhfx1rv1u782mttxsh7pf5qpphvgsgxurpgev45p11gjbkpcj816qj8r7g1yrp24n8c6u","pulse":"pulse-35emx1zgys6zajqx8j2tdcacn3eva6mee4txmc9s491tw3ub57t7cnhyabmqd22fd9f1j1e75ntr5e5k1qfvevr659qyts936j3zgym"};


//////////////////
// WEBPACK FOOTER
// ./src/views/TeamOfExperts/components/EmployeeTile/EmployeeTile.module.scss
// module id = 1335
// module chunks = 0